import { sessionPayload } from '../utils/session';
// src/components/AddDriver.js
import React, { useEffect, useState } from "react";
import { post } from "../services/api";
import ENDPOINTS from "../utils/constants/endpoints";
import { useParams, useNavigate } from "react-router-dom";

import { uploadDriverFile } from "../redux/slices/driverSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import FormSection from "../components/PersonnelFormSection";
import "./PersonnelForm.css";


const RequiredLabel = ({ label, required = false, htmlFor }) => (
  <label htmlFor={htmlFor} className="personnel-label">
    {label}
    {required && <span style={{ color: "red" }}> *</span>}
  </label>
);

const initialFormState = {
  school_id: "",
  previous_school_id: "",
  police_station_id: "",
  rto_office_id: "",
  firm_types: "",
  upload_photo: "",
  contact_person: "",
  father_name: "",
  designation: "",
  date_birth: "",
  experience_year: "",
  experience_month: "",
  present_address1: "",
  present_address2: "",
  present_address3: "",
  present_state_id: "",
  present_city_id: "",
  present_zip_code: "",
  last5year_address1: "",
  last5year_address2: "",
  last5year_address3: "",
  last5year_state_id: "",
  last5year_city_id: "",
  last5year_zip_code: "",
  permanent_address1: "",
  permanent_address2: "",
  permanent_address3: "",
  permanent_state_id: "",
  permanent_city_id: "",
  permanent_zip_code: "",
  mobile1: "",
  mobile2: "",
  email: "",
  aadhaar_no: "",
  upload_aadhaar: "",
  dl_no: "",
  dl_type: "",
  dl_rto_name: "",
  dl_issue_date: "",
  dl_renewal_date: "",
  upload_dl: "",
};

export default function AddDriverForm() {

  const dispatch = useDispatch();
  const { role_id, user } = useSelector((state) => state.auth);
  const { driverId } = useParams();
  const decodedId = decodeURIComponent(driverId);
  const navigate = useNavigate();
  const isEditMode = !!driverId;
  const { list: drivers } = useSelector((state) => state.drivers);
  // const{users,role_id}=useSelector((state)=>state.auth)

  const driver = drivers.find((d) => d.driver_id === decodedId);
  const [form, setForm] = useState({ ...initialFormState });
  const [loadingDriver, setLoadingDriver] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  // Masters
  const [schools, setSchools] = useState([]);
  const [policeStations, setPoliceStations] = useState([]);
  const [rtoOffices, setRtoOffices] = useState([]);
  const [firmTypes, setFirmTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState({
    present: [],
    permanent: [],
    last5year: [],
  });

  // Files
  const [errors, setErrors] = useState({});
  const [photoFile, setPhotoFile] = useState(null);
  const [aadhaarFile, setAadhaarFile] = useState(null);
  const [dlFile, setDlFile] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pendingUploads, setPendingUploads] = useState(0);
  const [uploadFailures, setUploadFailures] = useState({});
  // Attendants do not require driving licence information. Keep the check
  // case-insensitive because the category value comes from master data.
  // const isAttendant = form.firm_types.trim().toLowerCase() === "attendant";
  const category = form.firm_types?.trim().toLowerCase();

  const isAttendant =
    category === "attendant" ||
    category === "attender" ||
    category === "attendar";

  // --- Fetch driver (edit mode)
  useEffect(() => {
    if (!isEditMode || !driverId || !driver) return;

      setForm({
        contact_person: driver.contact_person || "",
        father_name: driver.father_name || "",
        designation: driver.designation || "",
        date_birth: driver.date_birth || "",
        experience_year: driver.experience_year || "",
        experience_month: driver.experience_month || "",
        present_address1: driver.present_address1 || "",
        present_address2: driver.present_address2 || "",
        present_address3: driver.present_address3 || "",
        present_state_id: driver.present_state_id || "",
        present_city_id: driver.present_city_id || "",
        present_zip_code: driver.present_zip_code || "",
        last5year_address1: driver.last5year_address1 || "",
        last5year_address2: driver.last5year_address2 || "",
        last5year_address3: driver.last5year_address3 || "",
        last5year_state_id: driver.last5year_state_id || "",
        last5year_city_id: driver.last5year_city_id || "",
        last5year_zip_code: driver.last5year_zip_code || "",
        permanent_address1: driver.permanent_address1 || "",
        permanent_address2: driver.permanent_address2 || "",
        permanent_address3: driver.permanent_address3 || "",
        permanent_state_id: driver.permanent_state_id || "",
        permanent_city_id: driver.permanent_city_id || "",
        permanent_zip_code: driver.permanent_zip_code || "",
        mobile1: driver.mobile1 || "",
        mobile2: driver.mobile2 || "",
        email: driver.email || "",
        aadhaar_no: driver.aadhaar_no || "",
        upload_aadhaar: driver.upload_aadhaar || "",
        dl_no: driver.dl_no || "",
        dl_type: driver.dl_type || "",
        dl_rto_name: driver.dl_rto_name || "",
        dl_issue_date: driver.dl_issue_date || "",
        dl_renewal_date: driver.dl_renewal_date || "",
        upload_dl: driver.upload_dl || "",
        upload_photo: driver.upload_photo || "",
        firm_types: driver.firm_types || "",
        police_station_id: driver.police_station_id || "",
        rto_office_id: driver.rto_office_id || "",
        previous_school_id: driver.previous_school_id || "",
        school_id: driver.school_id || "",
      });
      // 🔑 Fetch cities for prefilled states
      if (driver.present_state_id) fetchCities(driver.present_state_id, "present");
      if (driver.last5year_state_id) fetchCities(driver.last5year_state_id, "last5year");
      if (driver.permanent_state_id) fetchCities(driver.permanent_state_id, "permanent");
  }, [isEditMode, driverId, driver]);

  // --- Fetch masters
  useEffect(() => {
    const token = localStorage.getItem("token");
    let playloadPS = {
      token: token,
      users_id: sessionPayload().users_id,
      role_id: sessionPayload().role_id,
      showlist_status: "0",
      limit: "0",
      format: "Json",
    };

    const fetchData = async () => {
      try {
        const [sRes, pRes, rRes, stRes, fRes] = await Promise.all([
          post(ENDPOINTS.MASTER.SCHOOLS, playloadPS),
          post(ENDPOINTS.MASTER.POLICE_STATIONS, playloadPS),
          post(ENDPOINTS.MASTER.RTO_OFFICES, playloadPS),
          post(ENDPOINTS.MASTER.STATES),
          post(ENDPOINTS.MASTER.CATEGORY),
        ]);

        //setSchools(sRes?.data || []);

        if (role_id === "Nw==") {
          const userSchoolId = user?.users_id || "";
          const filteredSchools = (sRes?.data || []).filter(s => s.school_id === userSchoolId);
          setSchools(filteredSchools);
          setForm((prev) => ({
            ...prev,
            school_id:
              prev.school_id && prev.school_id !== ""
                ? prev.school_id
                : filteredSchools.length === 1
                  ? filteredSchools[0].school_id
                  : prev.school_id,
          }));
        }
        else {
          setSchools(sRes?.data || []);
        }
        setPoliceStations(pRes?.data || []);
        setRtoOffices(rRes?.data || []);
        setStates(stRes?.data || []);
        setFirmTypes(fRes?.data || []);
        setForm((prev) => ({
          ...prev,
          rto_office_id:
            prev.rto_office_id && prev.rto_office_id !== ""
              ? prev.rto_office_id
              : rRes?.data?.length === 1
                ? rRes.data[0].rto_office_id
                : prev.rto_office_id,
        }));
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  // --- Fetch cities
  const fetchCities = async (stateId, type) => {
    if (!stateId) return;
    try {
      const res = await post(ENDPOINTS.MASTER.CITIES, { state_id: stateId });

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setCities((prev) => ({ ...prev, [type]: res.data }));
      }
    } catch {
      setCities((prev) => ({ ...prev, [type]: [] }));
    }
  };

  // --- Input handlers
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setForm((prev) => ({ ...prev, [name]: value }));
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Remove error as soon as user starts correcting field
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
  const handleUpload = async (e, type, setFile, field) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFile(file);
    setPendingUploads(count => count + 1);
    setUploadFailures(previous => ({ ...previous, [field]: false }));
    try {
      const result = await dispatch(uploadDriverFile({ file, type }));
      const path = result?.payload?.data?.img_file;
      if (result?.payload?.status !== 'success' || typeof path !== 'string' || !path) throw new Error('Upload failed');
      setForm(previous => ({ ...previous, [field]: path }));
    } catch {
      setUploadFailures(previous => ({ ...previous, [field]: true }));
      alert('Document upload failed. Select the file again before saving.');
    } finally {
      setPendingUploads(count => count - 1);
    }
  };
  const handlePhotoChange = e => handleUpload(e, 'photo', setPhotoFile, 'upload_photo');
  const handleAadhaarChange = e => handleUpload(e, 'aadhaar', setAadhaarFile, 'upload_aadhaar');
  const handleDlChange = e => handleUpload(e, 'dl', setDlFile, 'upload_dl');

  const validateForm = () => {
    const newErrors = {};

    // --- Base Details ---
    // if (!form.school_id) newErrors.school_id = "School is required";
    // if (!form.police_station_id)
    //   newErrors.police_station_id = "Police Station is required";
    // if (!form.rto_office_id) newErrors.rto_office_id = "RTO Office is required";
    if (!form.firm_types) newErrors.firm_types = "Category is required";

    // --- Personal Details ---
    if (!form.contact_person.trim())
      newErrors.contact_person = "Full Name is required";
    else if (!/^[A-Za-z\s]+$/.test(form.contact_person))
      newErrors.contact_person = "Full Name must contain only letters";

    if (!form.father_name.trim())
      newErrors.father_name = "Father Name is required";
    else if (!/^[A-Za-z\s]+$/.test(form.father_name))
      newErrors.father_name = "Father Name must contain only letters";

    if (!form.designation.trim())
      newErrors.designation = "Designation is required";
    if (!form.date_birth) newErrors.date_birth = "Date of Birth is required";

    // --- Contact ---
    if (!form.mobile1.match(/^[6-9]\d{9}$/))
      newErrors.mobile1 = "Enter a valid 10-digit Mobile No";
    if (form.mobile2 && !form.mobile2.match(/^[6-9]\d{9}$/))
      newErrors.mobile2 = "Alternate Mobile No must be valid";
    if (form.email && !/\S+@\S+\.\S+/.test(form.email))
      newErrors.email = "Invalid Email Address";

    // --- Aadhaar ---
    if (!form.aadhaar_no.match(/^\d{12}$/))
      newErrors.aadhaar_no = "Aadhaar must be exactly 12 digits";
    if (!form.upload_aadhaar)
      newErrors.upload_aadhaar = "Aadhaar file is required";

    // --- DL ---
    // Licence details are optional for attendants, but validate any values
    // they choose to provide.
    // if (!isAttendant && !form.dl_no.trim()) newErrors.dl_no = "DL Number is required";
    // if (form.dl_no && form.dl_no.length < 6)
    //   newErrors.dl_no = "DL Number must be at least 6 characters";
    // if (!isAttendant && !form.dl_type) newErrors.dl_type = "DL Type is required";
    // if (!isAttendant && !form.dl_rto_name) newErrors.dl_rto_name = "DL RTO Name is required";
    // if (!isAttendant && !form.dl_issue_date)
    //   newErrors.dl_issue_date = "DL Issue Date is required";
    // if (!isAttendant && !form.dl_renewal_date)
    //   newErrors.dl_renewal_date = "DL Renewal Date is required";
    // if (form.dl_issue_date && form.dl_renewal_date) {
    //   if (new Date(form.dl_renewal_date) <= new Date(form.dl_issue_date)) {
    //     newErrors.dl_renewal_date = "Renewal Date must be after Issue Date";
    //   }
    // }
    // if (!isAttendant && !form.upload_dl) newErrors.upload_dl = "DL file is required";
    // --- DL ---
    if (!isAttendant) {
      if (!form.dl_no.trim()) {
        newErrors.dl_no = "DL Number is required";
      } else if (form.dl_no.length < 6) {
        newErrors.dl_no = "DL Number must be at least 6 characters";
      }

      if (!form.dl_type)
        newErrors.dl_type = "DL Type is required";

      if (!form.dl_rto_name)
        newErrors.dl_rto_name = "DL RTO Name is required";

      if (!form.dl_issue_date)
        newErrors.dl_issue_date = "DL Issue Date is required";

      if (!form.dl_renewal_date)
        newErrors.dl_renewal_date = "DL Renewal Date is required";

      if (
        form.dl_issue_date &&
        form.dl_renewal_date &&
        new Date(form.dl_renewal_date) <= new Date(form.dl_issue_date)
      ) {
        newErrors.dl_renewal_date =
          "Renewal Date must be after Issue Date";
      }

      if (!form.upload_dl)
        newErrors.upload_dl = "DL file is required";
    }
    // --- Addresses ---
    if (!form.present_address1.trim())
      newErrors.present_address1 = "Present Address is required";
    if (!form.present_state_id)
      newErrors.present_state_id = "Present State is required";
    if (!form.present_city_id)
      newErrors.present_city_id = "Present City is required";
    if (!form.present_zip_code)
      newErrors.present_zip_code = "Present Pincode is required";

    if (!form.permanent_address1.trim())
      newErrors.permanent_address1 = "Permanent Address is required";
    if (!form.permanent_state_id)
      newErrors.permanent_state_id = "Permanent State is required";
    if (!form.permanent_city_id)
      newErrors.permanent_city_id = "Permanent City is required";
    if (!form.permanent_zip_code)
      newErrors.permanent_zip_code = "Permanent Pincode is required";

    if (!form.last5year_address1.trim())
      newErrors.last5year_address1 = "Last 5 Years Address is required";
    if (!form.last5year_state_id)
      newErrors.last5year_state_id = "Last 5 Years State is required";
    if (!form.last5year_city_id)
      newErrors.last5year_city_id = "Last 5 Years City is required";
    if (!form.last5year_zip_code)
      newErrors.last5year_zip_code = "Last 5 Years Pincode is required";

    // --- Experience ---
    if (form.experience_year && Number(form.experience_year) < 0)
      newErrors.experience_year = "Years cannot be negative";
    if (
      form.experience_month &&
      (Number(form.experience_month) < 0 || Number(form.experience_month) > 11)
    )
      newErrors.experience_month = "Months must be 0–11";

    // --- Photo ---
    if (!form.upload_photo) newErrors.upload_photo = "Photo is required";

    setErrors(newErrors);
    return newErrors;
  };

  const focusFirstError = (validationErrors) => {
    const firstErrorField = Object.keys(validationErrors)[0];

    if (!firstErrorField) return;

    setTimeout(() => {
      const element = document.querySelector(
        `[name="${firstErrorField}"]`
      );

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        element.focus();
      }
    }, 100);
  };

  // --- Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting || pendingUploads || Object.values(uploadFailures).some(Boolean)) return;
    if (isEditMode && !driver) { alert("Existing record is unavailable. Return to the list before editing."); return; }
    if (!isVerified) {
      alert("You must verify the information before submitting.");
      return;
    }
    // const isValid = validateForm(); // returns true/false
    // if (!isValid) {
    //   alert("Please fix validation errors before submitting.");
    //   return;
    // }

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      focusFirstError(validationErrors);
      return;
    }
    setIsSubmitting(true);

    try {
      const payload = {
        token: localStorage.getItem("token") || "",
        users_id: sessionPayload().users_id,
        role_id: sessionPayload().role_id,

        ...(isEditMode && {
          driver_id: decodedId,
        }),

        ...form,

        upload_photo: form.upload_photo || "",
        upload_aadhaar: form.upload_aadhaar || "",
        upload_dl: form.upload_dl || "",
      };


      const endpoint = isEditMode
        ? ENDPOINTS.DRIVER.EDIT
        : ENDPOINTS.DRIVER.ADD;
      const response = await post(endpoint, payload);

      if (response?.status === "success") {
        alert(isEditMode ? "Driver updated!" : "Driver added!");
        navigate("/drivers");
      } else {
        alert("Unable to save this record. Please retry.");
      }
    } catch {
      alert("Unable to save this record. Please retry.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const personType = category === "conductor" ? "Conductor" : isAttendant ? "Attendant" : "Driver";

  return (
    <div className="personnel-page">
      <header className="personnel-header">
        <Button type="button" startIcon={<ArrowBack />} onClick={() => navigate(-1)} className="personnel-back">Back</Button>
        <div><h1>{isEditMode ? "Edit" : "Add"} {personType}</h1><p>Manage driver / conductor verification details</p></div>
      </header>



      {loadingDriver && <p>Loading...</p>}

      <form onSubmit={handleSubmit} aria-label="Personnel details" className="personnel-form">
        {/* --- Base Details --- */}
        <FormSection title="Basic Information / मूल विवरण">
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-school_id" label="School" required />
          <select
            id="personnel-school_id" name="school_id" aria-invalid={Boolean(errors.school_id)} aria-describedby={errors.school_id ? "error-school_id" : undefined}
            value={form.school_id}
            onChange={handleChange}
            disabled={schools.length === 1}
            className={`form-select ${errors.school_id ? "is-invalid" : ""}`}
          >
            {schools.map((s) => (
              <option key={s.school_id} value={s.school_id}>
                {s.firm_name}
              </option>
            ))}
          </select>
          {errors.school_id && (
            <div id="error-school_id" className="text-danger">{errors.school_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-police_station_id" label="Police Station" required />
          <select
            id="personnel-police_station_id" name="police_station_id" aria-invalid={Boolean(errors.police_station_id)} aria-describedby={errors.police_station_id ? "error-police_station_id" : undefined}
            value={form.police_station_id}
            onChange={handleChange}
            className={`form-select ${errors.police_station_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select Police Station</option>

            {policeStations.map((p) => (
              <option key={p.police_station_id} value={p.police_station_id}>
                {p.firm_name}
              </option>
            ))}
          </select>
          {errors.police_station_id && (
            <div id="error-police_station_id" className="text-danger">{errors.police_station_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-rto_office_id" label="RTO Office" required />
          <select
            id="personnel-rto_office_id" name="rto_office_id" aria-invalid={Boolean(errors.rto_office_id)} aria-describedby={errors.rto_office_id ? "error-rto_office_id" : undefined}
            value={form.rto_office_id}
            onChange={handleChange}
            disabled={rtoOffices.length === 1}
            className={`form-select ${errors.rto_office_id ? "is-invalid" : ""
              }`}
          >
            {rtoOffices.map((r) => (
              <option key={r.rto_office_id} value={r.rto_office_id}>
                {r.firm_types}
              </option>
            ))}
          </select>
          {errors.rto_office_id && (
            <div id="error-rto_office_id" className="text-danger">{errors.rto_office_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-firm_types" label="Category" required />
          <select
            id="personnel-firm_types" name="firm_types" aria-invalid={Boolean(errors.firm_types)} aria-describedby={errors.firm_types ? "error-firm_types" : undefined}
            value={form.firm_types}
            onChange={handleChange}
            className={`form-select ${errors.firm_types ? "is-invalid" : ""}`}
          >
            <option value="">Select Category</option>
            {firmTypes.map((f) => (
              <option key={f.dcc_id} value={f.dcc}>
                {f.dcc}
              </option>
            ))}
          </select>
          {errors.firm_types && (
            <div id="error-firm_types" className="text-danger">{errors.firm_types}</div>
          )}
        </div>

        {/* --- Personal Details --- */}
        </FormSection>
        <FormSection title="Personal Information / व्यक्तिगत विवरण">
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-contact_person" label="Name" required />
          <input
            type="text"
            id="personnel-contact_person" name="contact_person" aria-invalid={Boolean(errors.contact_person)} aria-describedby={errors.contact_person ? "error-contact_person" : undefined}
            placeholder="Enter Driver/Conductor Name"
            value={form.contact_person}
            onChange={handleChange}
            className={`form-control ${errors.contact_person ? "is-invalid" : ""
              }`}
            required
          />
          {errors.contact_person && (
            <div id="error-contact_person" className="text-danger">{errors.contact_person}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-father_name" label="Father Name" required />
          <input
            type="text"
            id="personnel-father_name" name="father_name" aria-invalid={Boolean(errors.father_name)} aria-describedby={errors.father_name ? "error-father_name" : undefined}
            placeholder="Enter Driver/Conductor Father Name"
            value={form.father_name}
            onChange={handleChange}
            className={`form-control ${errors.father_name ? "is-invalid" : ""}`}
            required
          />
          {errors.father_name && (
            <div id="error-father_name" className="text-danger">{errors.father_name}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-designation" label="Designation" required />
          {/* <label>Designation</label> */}
          <input
            type="text"
            id="personnel-designation" name="designation" aria-invalid={Boolean(errors.designation)} aria-describedby={errors.designation ? "error-designation" : undefined}
            placeholder="Designation"
            value={form.designation}
            onChange={handleChange}
            className={`form-control ${errors.designation ? "is-invalid" : ""}`}
            required
          />
          {errors.designation && (
            <div id="error-designation" className="text-danger">{errors.designation}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-date_birth" label="Date of Birth" required />
          <input
            type="date"
            id="personnel-date_birth" name="date_birth" aria-invalid={Boolean(errors.date_birth)} aria-describedby={errors.date_birth ? "error-date_birth" : undefined}
            value={form.date_birth}
            onChange={handleChange}
            className={`form-control ${errors.date_birth ? "is-invalid" : ""}`}
            required
          />
          {errors.date_birth && (
            <div id="error-date_birth" className="text-danger">{errors.date_birth}</div>
          )}
        </div>

        {/* --- Experience --- */}
        </FormSection>
        <FormSection title="Experience / अनुभव">
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-experience_year" label="Years" />
          <input
            type="number"
            id="personnel-experience_year" name="experience_year" aria-invalid={Boolean(errors.experience_year)} aria-describedby={errors.experience_year ? "error-experience_year" : undefined}
            value={form.experience_year}
            onChange={handleChange}
            className={`form-control ${errors.experience_year ? "is-invalid" : ""
              }`}

          />
          {errors.experience_year && (
            <div id="error-experience_year" className="text-danger">{errors.experience_year}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          {/* <label>Months</label> */}
          <RequiredLabel htmlFor="personnel-experience_month" label="Months" />
          <input
            type="number"
            id="personnel-experience_month" name="experience_month" aria-invalid={Boolean(errors.experience_month)} aria-describedby={errors.experience_month ? "error-experience_month" : undefined}
            value={form.experience_month}
            onChange={handleChange}
            className={`form-control ${errors.experience_month ? "is-invalid" : ""
              }`}

          />
          {errors.experience_month && (
            <div id="error-experience_month" className="text-danger">{errors.experience_month}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <label htmlFor="personnel-previous_school_id">Previous School / Organization</label>
          <input
            type="text"
            id="personnel-previous_school_id" name="previous_school_id" aria-invalid={Boolean(errors.previous_school_id)} aria-describedby={errors.previous_school_id ? "error-previous_school_id" : undefined}
            value={form.previous_school_id}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* --- Present Address --- */}

        </FormSection>
        <FormSection title="Current Address / वर्तमान पता">
        <div className="personnel-field-full">
          <RequiredLabel htmlFor="personnel-present_address1" label="Address" required />
          <input
            type="text"
            placeholder="Address "
            id="personnel-present_address1" name="present_address1" aria-invalid={Boolean(errors.present_address1)} aria-describedby={errors.present_address1 ? "error-present_address1" : undefined}
            value={form.present_address1}
            onChange={handleChange}
            className={`form-control ${errors.present_address1 ? "is-invalid" : ""
              }`}
            required
          />
          {errors.present_address1 && (
            <div id="error-present_address1" className="text-danger">{errors.present_address1}</div>
          )}
        </div>
        {/* <div className="col-12 col-sm-6 col-lg-4">
            <RequiredLabel htmlFor="personnel-present_address2" label="Address2" required/>
          <input
            type="text"
            placeholder="Address 2"
            id="personnel-present_address2" name="present_address2" aria-invalid={Boolean(errors.present_address2)} aria-describedby={errors.present_address2 ? "error-present_address2" : undefined}
            value={form.present_address2}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
            <RequiredLabel htmlFor="personnel-present_address3" label="Address3" />
          <input
            type="text"
            placeholder="Address 3"
            id="personnel-present_address3" name="present_address3" aria-invalid={Boolean(errors.present_address3)} aria-describedby={errors.present_address3 ? "error-present_address3" : undefined}
            value={form.present_address3}
            onChange={handleChange}
            className="form-control"
          />
        </div> */}
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-present_state_id" label="State" required />
          <select
            id="personnel-present_state_id" name="present_state_id" aria-invalid={Boolean(errors.present_state_id)} aria-describedby={errors.present_state_id ? "error-present_state_id" : undefined}
            value={form.present_state_id}
            required
            onChange={(e) => {
              handleChange(e);
              fetchCities(e.target.value, "present");
            }}
            className={`form-select ${errors.present_state_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select State</option>
            {states.map((s) => (
              <option key={s.state_id} value={s.state_id}>
                {s.state}
              </option>
            ))}
          </select>
          {errors.present_state_id && (
            <div id="error-present_state_id" className="text-danger">{errors.present_state_id}</div>
          )}
        </div>

        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-present_city_id" label="City" required />
          <select
            id="personnel-present_city_id" name="present_city_id" aria-invalid={Boolean(errors.present_city_id)} aria-describedby={errors.present_city_id ? "error-present_city_id" : undefined}
            value={form.present_city_id}
            required
            onChange={handleChange}
            className={`form-select ${errors.present_city_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select City</option>
            {cities.present.map((c) => (
              <option key={c.city_id} value={c.city_id}>
                {c.city}
              </option>
            ))}
          </select>
          {errors.present_city_id && (
            <div id="error-present_city_id" className="text-danger">{errors.present_city_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-present_zip_code" label="Pincode" required />
          <input
            type="text"
            placeholder="Pincode"
            id="personnel-present_zip_code" name="present_zip_code" aria-invalid={Boolean(errors.present_zip_code)} aria-describedby={errors.present_zip_code ? "error-present_zip_code" : undefined}
            value={form.present_zip_code}
            onChange={handleChange}
            className={`form-control ${errors.present_zip_code ? "is-invalid" : ""
              }`}
            required
          />
          {errors.present_zip_code && (
            <div id="error-present_zip_code" className="text-danger">{errors.present_zip_code}</div>
          )}
        </div>

        {/* --- Last 5 Years Address --- */}

        </FormSection>
        <FormSection title="Last 5 Years Address / पिछले 5 वर्षों का पता">
        <div className="personnel-field-full">
          <RequiredLabel htmlFor="personnel-last5year_address1" label="Address" required />
          <input
            type="text"
            placeholder="Address "
            id="personnel-last5year_address1" name="last5year_address1" aria-invalid={Boolean(errors.last5year_address1)} aria-describedby={errors.last5year_address1 ? "error-last5year_address1" : undefined}
            value={form.last5year_address1}
            onChange={handleChange}
            className={`form-control ${errors.last5year_address1 ? "is-invalid" : ""
              }`}

          />
          {errors.last5year_address1 && (
            <div id="error-last5year_address1" className="text-danger">{errors.last5year_address1}</div>
          )}
        </div>
        {/* <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-last5year_address2" label="Address2" />
          <input
            type="text"
            placeholder="Address 2"
            id="personnel-last5year_address2" name="last5year_address2" aria-invalid={Boolean(errors.last5year_address2)} aria-describedby={errors.last5year_address2 ? "error-last5year_address2" : undefined}
            value={form.last5year_address2}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-last5year_address3" label="Address3" />
          <input
            type="text"
            placeholder="Address 3"
            id="personnel-last5year_address3" name="last5year_address3" aria-invalid={Boolean(errors.last5year_address3)} aria-describedby={errors.last5year_address3 ? "error-last5year_address3" : undefined}
            value={form.last5year_address3}
            onChange={handleChange}
            className="form-control"
          />
        </div> */}
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-last5year_state_id" label="State" required />
          <select
            id="personnel-last5year_state_id" name="last5year_state_id" aria-invalid={Boolean(errors.last5year_state_id)} aria-describedby={errors.last5year_state_id ? "error-last5year_state_id" : undefined}
            value={form.last5year_state_id}
            onChange={(e) => {
              handleChange(e);
              fetchCities(e.target.value, "last5year");
            }}
            className={`form-select ${errors.last5year_state_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select State</option>
            {states.map((s) => (
              <option key={s.state_id} value={s.state_id}>
                {s.state}
              </option>
            ))}

          </select>
          {errors.last5year_state_id && (
            <div id="error-last5year_state_id" className="text-danger">{errors.last5year_state_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-last5year_city_id" label="City" required />
          <select
            id="personnel-last5year_city_id" name="last5year_city_id" aria-invalid={Boolean(errors.last5year_city_id)} aria-describedby={errors.last5year_city_id ? "error-last5year_city_id" : undefined}
            value={form.last5year_city_id}
            onChange={handleChange}
            className={`form-select ${errors.last5year_city_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select City</option>
            {cities.last5year.map((c) => (
              <option key={c.city_id} value={c.city_id}>
                {c.city}
              </option>
            ))}
          </select>
          {errors.last5year_city_id && (
            <div id="error-last5year_city_id" className="text-danger">{errors.last5year_city_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-last5year_zip_code" label="Pincode" required />
          <input
            type="text"
            placeholder="Pincode"
            id="personnel-last5year_zip_code" name="last5year_zip_code" aria-invalid={Boolean(errors.last5year_zip_code)} aria-describedby={errors.last5year_zip_code ? "error-last5year_zip_code" : undefined}
            value={form.last5year_zip_code}
            onChange={handleChange}
            className={`form-control ${errors.last5year_zip_code ? "is-invalid" : ""
              }`}

          />
          {errors.last5year_zip_code && (
            <div id="error-last5year_zip_code" className="text-danger">{errors.last5year_zip_code}</div>
          )}
        </div>

        {/* --- Permanent Address --- */}


        </FormSection>
        <FormSection title="Permanent Address / स्थायी पता">
        <div className="personnel-field-full">
          <RequiredLabel htmlFor="personnel-permanent_address1" label="Address" required />
          <input
            type="text"
            placeholder="Address "
            id="personnel-permanent_address1" name="permanent_address1" aria-invalid={Boolean(errors.permanent_address1)} aria-describedby={errors.permanent_address1 ? "error-permanent_address1" : undefined}
            value={form.permanent_address1}
            onChange={handleChange}
            className={`form-control ${errors.permanent_address1 ? "is-invalid" : ""
              }`}

          />
          {errors.permanent_address1 && (
            <div id="error-permanent_address1" className="text-danger">{errors.permanent_address1}</div>
          )}
        </div>
        {/* <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-permanent_address2" label="Address2"  />
          <input
            type="text"
            placeholder="Address 2"
            id="personnel-permanent_address2" name="permanent_address2" aria-invalid={Boolean(errors.permanent_address2)} aria-describedby={errors.permanent_address2 ? "error-permanent_address2" : undefined}
            value={form.permanent_address2}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-permanent_address3" label="Address3"  />
          <input
            type="text"
            placeholder="Address 3"
            id="personnel-permanent_address3" name="permanent_address3" aria-invalid={Boolean(errors.permanent_address3)} aria-describedby={errors.permanent_address3 ? "error-permanent_address3" : undefined}
            value={form.permanent_address3}
            onChange={handleChange}
            className="form-control"
          />
        </div> */}
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-permanent_state_id" label="State" required />
          <select
            id="personnel-permanent_state_id" name="permanent_state_id" aria-invalid={Boolean(errors.permanent_state_id)} aria-describedby={errors.permanent_state_id ? "error-permanent_state_id" : undefined}
            value={form.permanent_state_id}
            onChange={(e) => {
              handleChange(e);
              fetchCities(e.target.value, "permanent");
            }}
            className={`form-select ${errors.permanent_state_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select State</option>
            {states.map((s) => (
              <option key={s.state_id} value={s.state_id}>
                {s.state}
              </option>
            ))}
          </select>
          {errors.permanent_state_id && (
            <div id="error-permanent_state_id" className="text-danger">{errors.permanent_state_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-permanent_city_id" label="City" required />
          <select
            id="personnel-permanent_city_id" name="permanent_city_id" aria-invalid={Boolean(errors.permanent_city_id)} aria-describedby={errors.permanent_city_id ? "error-permanent_city_id" : undefined}
            value={form.permanent_city_id}
            onChange={handleChange}
            className={`form-select ${errors.permanent_city_id ? "is-invalid" : ""
              }`}
          >
            <option value="">Select City</option>
            {cities.permanent.map((c) => (
              <option key={c.city_id} value={c.city_id}>
                {c.city}
              </option>
            ))}
          </select>
          {errors.permanent_city_id && (
            <div id="error-permanent_city_id" className="text-danger">{errors.permanent_city_id}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-permanent_zip_code" label="Pincode" required />
          <input
            type="text"
            placeholder="Pincode"
            id="personnel-permanent_zip_code" name="permanent_zip_code" aria-invalid={Boolean(errors.permanent_zip_code)} aria-describedby={errors.permanent_zip_code ? "error-permanent_zip_code" : undefined}
            value={form.permanent_zip_code}
            onChange={handleChange}
            className={`form-control ${errors.permanent_zip_code ? "is-invalid" : ""
              }`}

          />
          {errors.permanent_zip_code && (
            <div id="error-permanent_zip_code" className="text-danger">{errors.permanent_zip_code}</div>
          )}
        </div>

        {/* --- Contact Details --- */}

        </FormSection>
        <FormSection title="Contact Details / सम्पर्क विवरण">
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-mobile1" label="Mobile1" required />
          <input
            type="text"
            id="personnel-mobile1" name="mobile1" aria-invalid={Boolean(errors.mobile1)} aria-describedby={errors.mobile1 ? "error-mobile1" : undefined}
            value={form.mobile1}
            onChange={handleChange}
            className={`form-control ${errors.mobile1 ? "is-invalid" : ""}`}
            required
          />
          {errors.mobile1 && (
            <div id="error-mobile1" className="text-danger">{errors.mobile1}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">

          <RequiredLabel htmlFor="personnel-mobile2" label="Mobile2" />
          <input
            type="text"
            id="personnel-mobile2" name="mobile2" aria-invalid={Boolean(errors.mobile2)} aria-describedby={errors.mobile2 ? "error-mobile2" : undefined}
            value={form.mobile2}
            onChange={handleChange}
            className={`form-control ${errors.mobile2 ? "is-invalid" : ""}`}
          />
          {errors.mobile2 && <div id="error-mobile2" className="text-danger">{errors.mobile2}</div>}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-email" label="Email" />

          <input
            type="email"
            id="personnel-email" name="email" aria-invalid={Boolean(errors.email)} aria-describedby={errors.email ? "error-email" : undefined}
            value={form.email}
            onChange={handleChange}
            className={`form-control ${errors.email ? "is-invalid" : ""}`}

          />
          {errors.email && <div id="error-email" className="text-danger">{errors.email}</div>}
        </div>

        {/* --- Aadhaar --- */}

        </FormSection>
        <FormSection title="Aadhaar Details / आधार विवरण">
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-aadhaar_no" label="Aadhar" required />
          <input
            type="text"
            id="personnel-aadhaar_no" name="aadhaar_no" aria-invalid={Boolean(errors.aadhaar_no)} aria-describedby={errors.aadhaar_no ? "error-aadhaar_no" : undefined}
            value={form.aadhaar_no}
            onChange={handleChange}
            placeholder="Aadhaar No"
            className={`form-control ${errors.aadhaar_no ? "is-invalid" : ""}`}
            required
          />
          {errors.aadhaar_no && (
            <div id="error-aadhaar_no" className="text-danger">{errors.aadhaar_no}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel label="Upload Aadhaar" required />

          {isEditMode && form.upload_aadhaar && !aadhaarFile && (
            <div className="mb-2">
              <img
                src={form.upload_aadhaar}
                alt="Aadhaar"
                style={{
                  width: "150px",
                  maxWidth: "100%",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                }}
              />
            </div>
          )}

          <input
            type="file"
            accept="image/*"
            onChange={handleAadhaarChange}
            required={!isEditMode}
            className={`form-control ${errors.upload_aadhaar ? "is-invalid" : ""
              }`}
           id="personnel-upload_aadhaar" name="upload_aadhaar" aria-label="Upload Aadhaar" aria-invalid={Boolean(errors.upload_aadhaar)} />
          {aadhaarFile && <small className="personnel-file-name">{aadhaarFile.name}</small>}
          {errors.upload_aadhaar && <div className="text-danger" role="alert">{errors.upload_aadhaar}</div>}
        </div>

        {/* --- DL --- */}

        </FormSection>
        {!isAttendant && (
          <>

        <FormSection title="Driving Licence / ड्राइविंग लाइसेंस विवरण">
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-dl_no" label="Driving Licence" required={!isAttendant} />
          <input
            type="text"
            id="personnel-dl_no" name="dl_no" aria-invalid={Boolean(errors.dl_no)} aria-describedby={errors.dl_no ? "error-dl_no" : undefined}
            value={form.dl_no}
            onChange={handleChange}
            placeholder="DL No"
            className={`form-control ${errors.dl_no ? "is-invalid" : ""}`}
            required={!isAttendant}
          />
          {errors.dl_no && <div id="error-dl_no" className="text-danger">{errors.dl_no}</div>}
          <small style={{ display: "block", color: "gray" }}>
            example - 1234455N7933
          </small>
        </div>

        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-dl_type" label="Driving Licence Type" required={!isAttendant} />
          <input
            type="text"
            id="personnel-dl_type" name="dl_type" aria-invalid={Boolean(errors.dl_type)} aria-describedby={errors.dl_type ? "error-dl_type" : undefined}
            value={form.dl_type}
            onChange={handleChange}
            placeholder="DL Type"
            className={`form-control ${errors.dl_type ? "is-invalid" : ""}`}
            required={!isAttendant}
          />
          {errors.dl_type && (
            <div id="error-dl_type" className="text-danger">{errors.dl_type}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-dl_rto_name" label="Driving Licence RTO" required={!isAttendant} />
          <input
            type="text"
            id="personnel-dl_rto_name" name="dl_rto_name" aria-invalid={Boolean(errors.dl_rto_name)} aria-describedby={errors.dl_rto_name ? "error-dl_rto_name" : undefined}
            value={form.dl_rto_name}
            onChange={handleChange}
            placeholder="DL RTO Name"
            className={`form-control ${errors.dl_rto_name ? "is-invalid" : ""}`}
            required={!isAttendant}
          />
          {errors.dl_rto_name && (
            <div id="error-dl_rto_name" className="text-danger">{errors.dl_rto_name}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel htmlFor="personnel-dl_issue_date" label="Issue Date" required={!isAttendant} />

          <input
            type="date"
            id="personnel-dl_issue_date" name="dl_issue_date" aria-invalid={Boolean(errors.dl_issue_date)} aria-describedby={errors.dl_issue_date ? "error-dl_issue_date" : undefined}
            value={form.dl_issue_date}
            onChange={handleChange}
            className={`form-control ${errors.dl_issue_date ? "is-invalid" : ""
              }`}
            required={!isAttendant}
          />
          {errors.dl_issue_date && (
            <div id="error-dl_issue_date" className="text-danger">{errors.dl_issue_date}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          {/* <label>Renewal Date</label> */}
          <RequiredLabel htmlFor="personnel-dl_renewal_date" label="Renewal Date" />
          <input
            type="date"
            id="personnel-dl_renewal_date" name="dl_renewal_date" aria-invalid={Boolean(errors.dl_renewal_date)} aria-describedby={errors.dl_renewal_date ? "error-dl_renewal_date" : undefined}
            value={form.dl_renewal_date}
            onChange={handleChange}
            className={`form-control ${errors.dl_renewal_date ? "is-invalid" : ""
              }`}
          />
          {errors.dl_renewal_date && (
            <div id="error-dl_renewal_date" className="text-danger">{errors.dl_renewal_date}</div>
          )}
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel
            label="Upload Driving Licence"
            required={!isAttendant}
          />

          {isEditMode && form.upload_dl && !dlFile && (
            <div className="mb-2">
              <img
                src={form.upload_dl}
                alt="Driving Licence"
                style={{
                  width: "150px",
                  maxWidth: "100%",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                }}
              />
            </div>
          )}

          <input
            type="file"
            accept="image/*"
            onChange={handleDlChange}
            required={!isEditMode && !isAttendant}
            className={`form-control ${errors.upload_dl ? "is-invalid" : ""
              }`}
           id="personnel-upload_dl" name="upload_dl" aria-label="Upload Driving Licence" aria-invalid={Boolean(errors.upload_dl)} />
          {dlFile && <small className="personnel-file-name">{dlFile.name}</small>}
          {errors.upload_dl && <div className="text-danger" role="alert">{errors.upload_dl}</div>}
        </div>
        </FormSection>
</>)}
        {/* --- Photo --- */}

        <FormSection title="Upload Photo / ड्राइवर/कंडक्टर फोटो">
        <div className="col-12 col-sm-6 col-lg-4">
          <RequiredLabel
            label="Driver/Conductor Photo"
            required
          />

          {isEditMode && form.upload_photo && !photoFile && (
            <div style={{ marginBottom: "10px" }}>
              <img
                src={form.upload_photo}
                alt="Driver"
                style={{
                  width: "120px",
                  maxWidth: "100%",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                }}
              />
            </div>
          )}

          <input
            type="file"
            accept="image/*"
            onChange={handlePhotoChange}
            required={!isEditMode}
            className={`form-control ${errors.upload_photo ? "is-invalid" : ""
              }`}
           id="personnel-upload_photo" name="upload_photo" aria-label="Driver/Conductor Photo" aria-invalid={Boolean(errors.upload_photo)} />
          {photoFile && <small className="personnel-file-name">{photoFile.name}</small>}
          {errors.upload_photo && <div className="text-danger" role="alert">{errors.upload_photo}</div>}

          {isEditMode && (
            <small className="text-muted">
              Select a new file only if you want to change the existing photo.
            </small>
          )}
        </div>

        </FormSection>
        <FormSection title="Verification / सत्यापन">
        <div className="form-check personnel-declaration">
          <input
            type="checkbox"
            className="form-check-input"
            id="verifiedCheck"
            checked={isVerified}
            required
            onChange={(e) => setIsVerified(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="verifiedCheck">
            <span className="personnel-label">I declare that the details provided are correct and have been duly
            verified by the School Principal. <span className="text-danger">*</span></span>
          </label>

        </div>

        </FormSection>
        {/* Submit */}
        <div className="personnel-actions">
          <Button type="button" variant="outlined" onClick={() => navigate(-1)}>Cancel</Button>
          <button

            type="submit"

            className="btn personnel-primary"
            disabled={isSubmitting}
          >
            {isSubmitting
              ? "Saving..."
              : isEditMode
                ? "Update"
                : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
